import { publicClient, privateClient } from './client';
import { ShippingInfo } from './ShippingInfo';

const transactionsShippingInfo = (pub: boolean) => new ShippingInfo(pub ? publicClient : privateClient);
export default transactionsShippingInfo;
